import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import ExternalLink from 'components/Widgets/ExternalLink';
import { useClaimContext } from 'contexts/ClaimContext';
import AddClaimButton from './AddClaimButton';
import Table from './Table';

export default function Main({ isPossibleAddClaim }) {
  const { dispatch, actions } = useClaimContext();

  useEffect(() => {
    actions.loadClaims(dispatch);
  }, []);

  return (
    <div className="content">
      <section>
        <Row className="mb-3">
          <Col>
            <h1>Talent Insurance</h1>
          </Col>

          <Col xs="auto">
            <AddClaimButton isPossibleAddClaim={isPossibleAddClaim} />
          </Col>
        </Row>

        <p>
          LeggUP Talent Insurance allows you to submit a claim for any
          employee who completed a LeggUP Program.
        </p>

        <p>
          For policy details, click
          {' '}
          <ExternalLink
            href="https://help.leggup.com/en/articles/6622981-talent-insurance-refund-policy"
            variant={null}
          >
            here
          </ExternalLink>
          .
        </p>
      </section>

      <section className="pt-2">
        <Table isPossibleAddClaim={isPossibleAddClaim} />
      </section>
    </div>
  );
}

Main.propTypes = {
  isPossibleAddClaim: PropTypes.bool,
};

Main.defaultProps = {
  isPossibleAddClaim: false,
};
